module.exports = __webpack_public_path__ + "static/img/yd-bg1.f7d3e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-bg1.jpg
// module id = fWaw
// module chunks = 0